import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AssetViewer {
    isOpen: boolean;
}
const initialState: AssetViewer = {
    isOpen: false,
};
const AssetViewerSlice = createSlice({
    name: 'AssetViewerSlice',
    initialState,
    reducers: {
        setAssetViewerOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setAssetViewerOpen } = AssetViewerSlice.actions;
export default AssetViewerSlice.reducer;
